<template>
	<div class="confirm-size-wrapper">
		<VeeForm :validation-schema="confirmValidationSchema" v-slot="{ handleSubmit, errors, setFieldValue }" ref="sizeForm" as="div">
			<form class="row confirm-size-form" @submit="handleSubmit($event, onSizeSubmit)" method="post">
				<div class="col-12 col-lg-4 mb-2 mb-sm-4">
					<div class="border-thin border-dark rounded-lg p-3">
						<h1 class="h3 text-start3">Confirm your vehicle details</h1>
						<div class="d-sm-flex d-md-block d-xxl-flex align-items-center gap-1 my-3">
							<span class="d-block mb-2 mb-sm-0 fw-bold">Registration:</span>
							<reg-form-custom :postcode="postcode" :reg="car.registration" :image-base-path="imageBasePath"></reg-form-custom>
						</div>
						<div class="d-flex align-items-center mt-2 model">
							<span class="d-inline-block me-2 fw-bold">Model:</span>
							<small class="d-inline-block">{{ car.make }} {{ car.model }} {{ car.colour ? '- ' + car.colour : '' }}</small>
						</div>
						<hr v-if="car.make != null && runFlatCheckMakes.includes(car.make.toLowerCase())">
						<div class="run-flat-check d-flex flex-column flex-sm-row flex-md-column flex-xl-row justify-content-between" v-if="car.make != null && runFlatCheckMakes.includes(car.make.toLowerCase())">
							<div>
								<span class="d-block mb-1 fw-bold">Do you currently have<br class="d-none d-md-block"> run flat tyres fitted?</span>
								<a :href="this.baseUrl + '/run-flat-tyres'" class="text-underline" target="_blank">How to check if your tyres are runflat</a>
								<div class="run-flat-select mt-2">
									<ul class="p-0 mb-0">
										<li class="d-inline-block me-2">
											<Field name="run_flat" id="rf_yes" type="radio" class="form-check-input" :value="1" :checked="(runFlatLanding == true ? 'checked' : '')"/>
											<label class="form-check-label" for="rf_yes">Yes</label>
										</li>
										<li class="d-inline-block">
											<Field name="run_flat" id="rf_no" type="radio" class="form-check-input" :value="0" />
											<label class="form-check-label" for="rf_no">No</label>
										</li>
									</ul>
								</div>
							</div>
							<img class="mt-2 mt-sm-0 mt-md-2 mt-lg-0 ms-3 d-none d-xl-block" :src="this.baseUrl + '/assets/img/generic_images/run_flat_check.png'" alt="Run Flat Check" />
						</div>
						<Field v-else name="run_flat" type="hidden" :value="runFlat == true ? 1 : 0" />
					</div>
				</div>
				<div class="col-12 col-lg-8  mb-2 mb-sm-4">
					<div class="rounded-lg border-thin border-dark p-3">
						<h2 class="h3 text-start">Select a tyre size</h2>
						<confirm-size-tyre-options
							:size-types="car.sizeTypes"
						></confirm-size-tyre-options>
						<confirm-size-options :options="car.options" :errors="errors"></confirm-size-options>
						<p id="SizeFormAnchor">Not your tyre size? <span class="cursor-pointer text-underline" @click="toggleSizeForm(setFieldValue)">Click here to enter the correct size</span></p>
						<Field as="hidden" name="showSizeForm" v-model="showSizeForm"></Field>
						<Field as="hidden" name="manualSize" v-model="manualSize"/>
						<transition name="fade">
							<div id="sizeFormAnchor">
								<size-form-custom
									v-if="showSizeForm"
									:postcode="postcode"
									:options="sizeOptions"
									:errors="errors"
								></size-form-custom>
							</div>
						</transition>
						<div class="col-12 my-2">
							<div class="alert border-teal alert-info d-flex align-items-center" role="alert" style="border-color: #13A1A7; color: #171717;">
								<i class="fa-lg fa-solid fa-triangle-exclamation my-3 my-sm-0 me-3"></i>
								<div>
									<p class="mb-0">Check your tyres to ensure you add the right tyre sizes to your order.</p>
									<a class="text-underline" :href="this.baseUrl + '/tyre-info'" target="_blank" title="Check your tyres">How to check your tyre size.</a>
								</div>
							</div>
						</div>
						<div class="col-12 text-center mb-2 mt-3">
							<Field v-if="brand" name="brand" type="hidden" :value="brand" />
							<button type="submit" class="btn btn-primary w-auto py-2 px-md-4 mb-2 d-block ms-auto">
								Continue to select tyres <i class="fa-solid fa-arrow-right ms-2"></i>
							</button>
						</div>
					</div>
				</div>
			</form>
		</VeeForm>
	</div>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate';
    import * as yup from 'yup';
    import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';
	
    export default {
	    props: [
			'car',
			'runFlatCheckMakes',
			'runFlatLanding',
			'runFlat',
			'electricHybrid',
			'sizeOptions',
			'imageBasePath',
			'postcode',
			'brand'
		],
	    components: { VeeForm, Field, ErrorMessage},
	    data() {
			const confirmValidationSchema = yup.object({
	            size: yup.string().when('showSizeForm', {
                    is: false,
                    then: yup.string().required('Please select a tyre size to proceed')
                }),
				width: yup.string().when('showSizeForm', {
                    is: true,
                    then: yup.string().required('Width is required')
                }),
                profile: yup.string().when('showSizeForm', {
                    is: true,
                    then: yup.string().required('Profile is required')
                }),
                rim: yup.string().when('showSizeForm', {
                    is: true,
                    then: yup.string().required('Rim is required')
                })
	        });

	        return {
	            tyrePosition: 'same',
	            vehicle_type: '',
				confirmValidationSchema,
				showSizeForm: false,
                manualSize: {
                    width: null,
                    profile: null,
                    rim: null,
                    speed: null,
                    load: null
                },
				initialSizeValue: ''
	        }
	    },
	    mounted() {
			//removes loading placeholder - fixes CLS issue
			document.querySelector('#loadingPlaceholder').style.display = 'none';

			let vm = this;
            this.emitter.on('updateTyrePosition', function(value) {
                vm.tyrePosition = value;
            });

			//Closes manual size form when a size input is selected
			this.emitter.on('closeSizeForm', function(value) {
                vm.showSizeForm = false;
				vm.initialSizeValue = value;
				vm.$refs.sizeForm.setFieldValue('size', value);
            });

			//Updates manual size object on change of inputs
			this.emitter.on('updateManualSize', function(data) {
                vm.manualSize[data.name] = data.value;
            });
	    },
	    methods: {
			toggleSizeForm(setFieldValue) {
				//Sets size option to blank to trigger validation if closing sizeForm, otherwise resets size field back to original value.
				if(this.showSizeForm) {
					setFieldValue('size', '');
				}
				else {
					setFieldValue('size', this.initialSizeValue);
				}

				this.showSizeForm = !this.showSizeForm;
				
				if(this.showSizeForm == true && Math.max(document.documentElement.clientWidth <= 992)) {
					document.getElementById('SizeFormAnchor').scrollIntoView({ behavior: 'smooth' });
				}
				
				//Clear selected size radio buttons
				var radios = document.getElementsByName('size');
				for(var i=0;i<radios.length;i++) {
					radios[i].checked = false;
				}
			},
			async onSizeSubmit(values, actions) {
				this.emitter.emit('isLoading', true);

				var formData = new FormData();

				if(this.showSizeForm) {
					//Format size string to how it is expected
					var manualSizeString = this.manualSize.width + '/' + this.manualSize.profile + '/' + this.manualSize.rim + (this.manualSize.speed ? '/' + this.manualSize.speed : '') + (this.manualSize.load ? this.manualSize.load : '');
					formData.append('size', manualSizeString);
				}
				else {
					//formattedSize is needed because sometimes the size values are exactly the same (e.g. front/same), and there are multiple of them,
					//so to prevent a selection bug, we are stripping off the added string that made the value unique.
					var formattedSize = values.size.split('_')[0];
					formData.append('size', formattedSize);
				}

                formData.append('run_flat', values.run_flat);
				formData.append('tyre_position', this.tyrePosition);
				formData.append('brand', values.brand);
				formData.append('jsonOnly', true);

				var response = await axios.post('/enter-size-submit', formData);

				if(response.status == 200 && response.data != '') {
					await navigateWithAttribution(this.baseUrl + '/' + response.data);
				}
				else {
					this.emitter.emit('isLoading', false);
				}
			}
	    },
	    computed: {

	    }
	}
</script>
<style lang="scss" scoped>
	@import '@frontendAssets/sass/_variables.scss';
	.confirm-size-wrapper {
		.confirm-size-form {
			ul {
				list-style-type: none;
			}
			.title {
				font-size: 16px;
				margin: 15px 0 5px;
			}
			.how-to-check-run-flat {
				font-size: 16px;
				display: inline-block;
			}
			.tyre-size-label {
				font-size: 20px
			}
			.reg-size-form {
				box-shadow: none;
				width: 100%;
			}
		}
		.run-flat-check {
			text-align: left;
			b {
				font-size: 18px;
			}
			label {
				cursor: pointer;
				padding: 2px 10px;
				width: auto;
			}
			img {
				height: 123px;
				width: 123px;
			}
		}
		.divider {
			height: 2px !important;
			width: 100%;
			@media screen and (min-width: 768px) {
				height: 95% !important;
				width: 2px;
			}
			margin: 10px auto;
			background-color: #D3D3D3;
		}
		.fade-enter-active,
		.fade-leave-active {
			transition: opacity 0.5s ease;
		}

		.fade-enter-from,
		.fade-leave-to {
			opacity: 0;
		}
	}
	.form-switch .form-check-input {
		background-color: $green;
		border-color: $green;
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
	}
	.form-switch .form-check-input:focus {
		border-color: rgba(0, 0, 0, 0.25);
		border: none;
		outline: 0;
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
	}
	.form-switch .form-check-input:checked {
		background-color: $green;
		border-color: $green;
		border: none;
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
	}
</style>